import { Stack } from '@mui/material'
import { useState } from 'react'

import Header from '~/features/chatbot/components/linkView/header'
import Intro from '~/features/chatbot/components/linkView/intro'
import useIsEmbeddedChat from '~/features/chatbot/hooks/useIsEmbeddedChat'
import Simple from '~/features/chatbotV2/components/simple'

// Clone of features/chatbot/components/linkView (v1) — only the Simple
// import points at the v2 clone; Header/Intro are pure presentation, reused
// as-is from the original chatbot feature.
function LinkView() {
  const { isEmbedded, isMinimized } = useIsEmbeddedChat()
  const showLinks = !isEmbedded || !isMinimized

  const [showChatbot, setShowChatbot] = useState(false)

  if (showChatbot) {
    return <Simple />
  }

  return (
    <Stack
      sx={{
        height: '100%',
        width: '100%',
        minHeight: 0,
        overflow: 'hidden',
      }}
      useFlexGap
    >
      <Header />
      {showLinks && <Intro setShowChatbot={setShowChatbot} />}
    </Stack>
  )
}

export default LinkView
